import React from 'react';

export const Friend: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={30}
    height={30}
    {...props}
  >
    <defs>
      <path
        id="aFriendsIcon"
        d="M22.314 19.888h.01-.01zM5.44 21.985h16.813v-2.12c-5.938-2.266-6.662-3.165-6.873-3.83a.727.727 0 0 1-.035-.223v-.91c0-.196.078-.384.216-.523.53-.534.942-1.282 1.19-2.16a.738.738 0 0 1 .293-.408.72.72 0 0 0 .139-1.057.745.745 0 0 1-.17-.473V8.242c0-1.886-1.036-2.802-3.166-2.802-2.07 0-3.167.969-3.167 2.802v2.04a.737.737 0 0 1-.17.472.724.724 0 0 0 .14 1.057.74.74 0 0 1 .29.406c.25.88.663 1.628 1.192 2.162a.738.738 0 0 1 .216.522v.911a.738.738 0 0 1-.035.224c-.21.663-.932 1.56-6.873 3.83v2.119zm16.907 1.483h-17a1.392 1.392 0 0 1-1.391-1.39v-2.277a1.4 1.4 0 0 1 .895-1.299c4.726-1.802 5.78-2.607 6.013-2.88v-.429c-.555-.632-.993-1.43-1.281-2.34a2.214 2.214 0 0 1-.706-1.335 2.192 2.192 0 0 1 .32-1.475v-1.8c0-2.685 1.738-4.287 4.65-4.287 2.912 0 4.65 1.602 4.65 4.286v1.8c.278.442.392.956.32 1.477-.072.516-.325.99-.707 1.335-.288.908-.725 1.707-1.281 2.34v.44c.202.237 1.215 1.04 6.012 2.868.536.204.895.725.895 1.299v2.278c0 .766-.623 1.39-1.39 1.39z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width={30} height={30} fill="#A8ACB1" fillOpacity={0.15} rx={3} />
      <g transform="translate(1.154 1.154)">
        <mask id="bFriendsIcon" fill="#fff">
          <use xlinkHref="#aFriendsIcon" />
        </mask>
        <use fill="#FFF" xlinkHref="#aFriendsIcon" />
        <g fill="#FFF" mask="url(#bFriendsIcon)">
          <path d="M0 0h27.692v27.692H0z" />
        </g>
      </g>
    </g>
  </svg>
);
